var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgSpinner = function SvgSpinner(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100px",
    height: "100px",
    viewBox: "0 0 100 100",
    preserveAspectRatio: "xMidYMid",
    className: "uil-default",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100,
    fill: "none",
    className: "bk"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 46.5,
    y: 40,
    width: 7,
    height: 20,
    rx: 5,
    ry: 5,
    fill: "#ffffff",
    transform: "rotate(0 50 50) translate(0 -30)"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    from: 1,
    to: 0,
    dur: "1s",
    begin: "0s",
    repeatCount: "indefinite"
  }))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 46.5,
    y: 40,
    width: 7,
    height: 20,
    rx: 5,
    ry: 5,
    fill: "#ffffff",
    transform: "rotate(30 50 50) translate(0 -30)"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    from: 1,
    to: 0,
    dur: "1s",
    begin: "0.08333333333333333s",
    repeatCount: "indefinite"
  }))), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 46.5,
    y: 40,
    width: 7,
    height: 20,
    rx: 5,
    ry: 5,
    fill: "#ffffff",
    transform: "rotate(60 50 50) translate(0 -30)"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    from: 1,
    to: 0,
    dur: "1s",
    begin: "0.16666666666666666s",
    repeatCount: "indefinite"
  }))), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 46.5,
    y: 40,
    width: 7,
    height: 20,
    rx: 5,
    ry: 5,
    fill: "#ffffff",
    transform: "rotate(90 50 50) translate(0 -30)"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    from: 1,
    to: 0,
    dur: "1s",
    begin: "0.25s",
    repeatCount: "indefinite"
  }))), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 46.5,
    y: 40,
    width: 7,
    height: 20,
    rx: 5,
    ry: 5,
    fill: "#ffffff",
    transform: "rotate(120 50 50) translate(0 -30)"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    from: 1,
    to: 0,
    dur: "1s",
    begin: "0.3333333333333333s",
    repeatCount: "indefinite"
  }))), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 46.5,
    y: 40,
    width: 7,
    height: 20,
    rx: 5,
    ry: 5,
    fill: "#ffffff",
    transform: "rotate(150 50 50) translate(0 -30)"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    from: 1,
    to: 0,
    dur: "1s",
    begin: "0.4166666666666667s",
    repeatCount: "indefinite"
  }))), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 46.5,
    y: 40,
    width: 7,
    height: 20,
    rx: 5,
    ry: 5,
    fill: "#ffffff",
    transform: "rotate(180 50 50) translate(0 -30)"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    from: 1,
    to: 0,
    dur: "1s",
    begin: "0.5s",
    repeatCount: "indefinite"
  }))), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 46.5,
    y: 40,
    width: 7,
    height: 20,
    rx: 5,
    ry: 5,
    fill: "#ffffff",
    transform: "rotate(210 50 50) translate(0 -30)"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    from: 1,
    to: 0,
    dur: "1s",
    begin: "0.5833333333333334s",
    repeatCount: "indefinite"
  }))), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 46.5,
    y: 40,
    width: 7,
    height: 20,
    rx: 5,
    ry: 5,
    fill: "#ffffff",
    transform: "rotate(240 50 50) translate(0 -30)"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    from: 1,
    to: 0,
    dur: "1s",
    begin: "0.6666666666666666s",
    repeatCount: "indefinite"
  }))), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 46.5,
    y: 40,
    width: 7,
    height: 20,
    rx: 5,
    ry: 5,
    fill: "#ffffff",
    transform: "rotate(270 50 50) translate(0 -30)"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    from: 1,
    to: 0,
    dur: "1s",
    begin: "0.75s",
    repeatCount: "indefinite"
  }))), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 46.5,
    y: 40,
    width: 7,
    height: 20,
    rx: 5,
    ry: 5,
    fill: "#ffffff",
    transform: "rotate(300 50 50) translate(0 -30)"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    from: 1,
    to: 0,
    dur: "1s",
    begin: "0.8333333333333334s",
    repeatCount: "indefinite"
  }))), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 46.5,
    y: 40,
    width: 7,
    height: 20,
    rx: 5,
    ry: 5,
    fill: "#ffffff",
    transform: "rotate(330 50 50) translate(0 -30)"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    from: 1,
    to: 0,
    dur: "1s",
    begin: "0.9166666666666666s",
    repeatCount: "indefinite"
  }))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSpinner, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/spinner.6f2ab766.svg";
export { ForwardRef as ReactComponent };